module.exports = __webpack_public_path__ + "media/src/images/menu-128-324052eff6f12cd88356fb78e8e05297.png";